import { render, staticRenderFns } from "./VerticalsSection.vue?vue&type=template&id=75da2e0e&scoped=true"
import script from "./VerticalsSection.vue?vue&type=script&lang=ts"
export * from "./VerticalsSection.vue?vue&type=script&lang=ts"
import style0 from "./VerticalsSection.vue?vue&type=style&index=0&id=75da2e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75da2e0e",
  null
  
)

export default component.exports